import { render, staticRenderFns } from "./GameArea.vue?vue&type=template&id=5186aaa3&scoped=true&"
import script from "./GameArea.vue?vue&type=script&lang=ts&"
export * from "./GameArea.vue?vue&type=script&lang=ts&"
import style0 from "./GameArea.vue?vue&type=style&index=0&id=5186aaa3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5186aaa3",
  null
  
)

export default component.exports